"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserNotPermittedError = void 0;
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when a fetch quiz field failed validation
 * @param {string} field the field that failed validation
 * @param {string} message the validation message
 */
class UserNotPermittedError extends client_library_1.ExtendableError {
    constructor() {
        super(`User not permitted to perform that operation`);
    }
}
exports.UserNotPermittedError = UserNotPermittedError;
//# sourceMappingURL=UserNotPermittedError.js.map